import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAllMyEvents = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Primary",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_525",
		"data-name": "Path 525",
		d: "M-1.58-.91H-.285V.473a4.2,4.2,0,0,0,1.46-.847,4.442,4.442,0,0,0,.682-1.708A3.263,3.263,0,0,0,1.1-4.121a3.158,3.158,0,0,0-.876-.62A2.512,2.512,0,0,0-.868-4.995a3.429,3.429,0,0,0-2.109.874A3.2,3.2,0,0,0-3.71-2.082,2.864,2.864,0,0,0-2.977-.374a2.779,2.779,0,0,0,1.4.847L-.9,4.345l-3.04,1.96A30.95,30.95,0,0,1-7.065,4,3.98,3.98,0,0,1-3.805,5.441c0,.014,2.225-1.57,2.225-1.57V1.784h0A4.44,4.44,0,0,1-3.805.636,4.089,4.089,0,0,1-4.985-2.082a4.232,4.232,0,0,1,1.179-3,4.415,4.415,0,0,1,1.257-.87A5.253,5.253,0,0,1-.973-6.3,4.7,4.7,0,0,1,2.04-5.084a4.674,4.674,0,0,1,1.1,3A4.294,4.294,0,0,1,2.04.636,3.7,3.7,0,0,1-.285,1.784V3.871s2.25,1.57,2.235,1.57a4.044,4.044,0,1,1,3.137,6.668A4.023,4.023,0,0,1,.977,8.16a3.823,3.823,0,0,1,.3-1.644L-.9,4.974-3.119,6.515a3.748,3.748,0,0,1,.3,1.644,4.058,4.058,0,0,1-4.092,3.949A4.06,4.06,0,0,1-10.926,8.16,4.082,4.082,0,0,1-7.065,4l3.127,2.309s-.194,2.248-.155,1.854a2.378,2.378,0,0,0-.118-.85L-6.619,9.017l-.726-1.07,2.527-1.773a2.694,2.694,0,0,0-2.246-.88,2.816,2.816,0,0,0-2.6,2.866,2.816,2.816,0,0,0,2.755,2.684A2.851,2.851,0,0,0-4.092,8.16s.069-1.553.155-1.854.19.65.19.65l-.19-.65c0-.125,3.04-1.96,3.04-1.96A27.21,27.21,0,0,1,2.576,6.72a2.8,2.8,0,0,0,2.511,4.124A2.863,2.863,0,0,0,7.8,8.16,2.792,2.792,0,0,0,2.576,6.72L.694,5.441-.9,4.345h0L-1.81.636l.23-.163Z",
		transform: "translate(12.931 9.298)"
	}), /* @__PURE__ */ _jsx("rect", {
		id: "Rectangle_676",
		"data-name": "Rectangle 676",
		width: 24,
		height: 24,
		fill: "rgba(255,255,255,0)"
	})]
});
export default SvgAllMyEvents;
